import { APIError } from "@limrun/api/core/error";
import { Link } from "react-router-dom";
import { ToastAction } from "@/components/ui/toast";
import { toast } from "@/components/ui/use-toast";
import { formatErrorMessage } from "@/utils/format";

export function toastInstanceCreationError(error: unknown) {
  // The SDK keeps the API response body under error, including its billing reason.
  const body = error instanceof APIError ? error.error : undefined;
  const reason = body && "reason" in body ? body.reason : undefined;
  const message = body && "message" in body ? body.message : undefined;
  let title = "Could not create your device";
  let description = formatErrorMessage(
    typeof message === "string" && message.trim()
      ? message
      : error instanceof Error
        ? error.message
        : "Something went wrong. Please try again.",
  );

  switch (reason) {
    case "NoSubscription":
      title = "No credits or active plan";
      description = "Your organization has no remaining credits and no active plan. Open billing to add credits or subscribe.";
      break;
    case "NoRemainingMinutes":
      title = "No available minutes";
      description = "Your organization has no remaining credits or usable plan minutes. Open billing to add credits or manage your plan.";
      break;
    case "ConcurrencyLimitReached":
      description = "You can't create more instances at the same time. Stop an instance or raise the concurrency limit in settings.";
      break;
  }

  toast({
    title,
    description,
    variant: "destructive",
    action: reason === "NoSubscription" || reason === "NoRemainingMinutes" ? (
      <ToastAction altText="Open billing" asChild>
        <Link to="/billing">Open billing</Link>
      </ToastAction>
    ) : undefined,
  });
}
